import React from 'react';
import PropTypes from 'prop-types';

const Cite = ({ text }) => (
  <cite>{text}</cite>
);

Cite.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Cite;



// WEBPACK FOOTER //
// ./library/app/components/Content/Cite.js